import React, { useState, useEffect } from 'react';
import { NavLink, BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import './components/Home/App.css';
import ScrollToTop from './components/Home/ScrollToTop';
import BackToTopButton from './components/Home/BackToTopButton';
import WhatsAppButton from './components/Home/WhatsAppButton';

import Home from './components/Home/Home';
import About from './components/Home/About';
import About2 from './components/Home/About2';
import Contact from './components/Home/Contact';
import Greeting from './components/Home/Greeting';
import ServiceMain from './components/Home/ServiceMain';
import FeatureCard from './components/Home/FeatureCard';
import Gallery from './components/Home/Gallery';
import SriLanka from './components/Home/SriLanka';
import China from './components/Home/China';
import InfoSection from './components/Home/InfoSection';
import BeutyOfSriLanka from './components/Home/BeutyOfSriLanka';
import Kandy from './components/Home/Kandy';
import Dabulle from './components/Home/Dabulle';
import Anuradhapura from './components/Home/Anuradhapura';
import Polonnaruwa from './components/Home/Polonnaruwa';
import Yala from './components/Home/Yala';
import Galle from './components/Home/Galle';
import Jaffna from './components/Home/Jaffna';
import NuweraElliya from './components/Home/NuweraElliya';
import Ella from './components/Home/Ella';
import Colombo from './components/Home/Colombo';
import InfoSectionChina from './components/Home/InfoSectionChina';
import Beijing from './components/Home/Beijing';
import Shanghai from './components/Home/Shanghai';
import Guangzhou from './components/Home/Guangzhou';
import Xian from './components/Home/Xian';
import Wuhan from './components/Home/Wuhan';
import Chengdu from './components/Home/Chengdu';
import Zhangjiajie from './components/Home/Zhangjiajie';
import Guilin from './components/Home/Guilin';
import Hangzhou from './components/Home/Hangzhou';
import Harbin from './components/Home/Harbin';
import Loader from "./components/Home/Loader";
import QR from "./components/Home/QR";




const App = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
    const [loading, setLoading] = useState(true);



  const closeMenu = () => setMenuOpen(false);
  const toggleMenu = () => setMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const menu = document.querySelector('.nav-links-container');
      const hamburger = document.querySelector('.hamburger-icon');
      if (menu && !menu.contains(event.target) && !hamburger.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, []);

      useEffect(() => {
        const timer = setTimeout(() => {
          setLoading(false);
        }, 2000);
        return () => clearTimeout(timer);
      }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden'; // Prevent scroll
    } else {
      document.body.style.overflow = 'auto'; // Allow scroll
    }



    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen]);

  useEffect(() => {
      const handleScroll = () => {
        const navbar = document.querySelector('.navbar');
        if (navbar) {
          if (window.scrollY > 0) {
            navbar.classList.add('scrolled');
          } else {
            navbar.classList.remove('scrolled');
          }
        }
      };

      window.addEventListener('scroll', handleScroll);
      // Trigger handleScroll immediately to apply the effect on page load
      handleScroll();

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [location.pathname]); // Re-run effect when route changes

  if (loading) {
      return <Loader />;
    }


  return (
    <div>
      <nav className="modern-navbar">
       <div className="nav-inner">
        <div className="nav-left">
          <Link to="/home" className="logo-link">
            <img src={`${process.env.PUBLIC_URL}/images/login2.png`}  className="nav-logo" />
          </Link>

          <div className="nav-text">
            <h1 className="nav-heading">WASALA TOURS</h1>
            <p className="nav-subtitle">~ Your Tour Planning Experts ~</p>
          </div>
        </div>


          <div className={`nav-center ${isMenuOpen ? 'open' : ''}`}>
            <ul className="nav-links">
              <li><NavLink to="/home" onClick={closeMenu}>Home</NavLink></li>
              <li><NavLink to="/about" onClick={closeMenu}>About</NavLink></li>
              <li><NavLink to="/service" onClick={closeMenu}>Services</NavLink></li>
              <li><NavLink to="/gallery" onClick={closeMenu}>Gallery</NavLink></li>
              <li><NavLink to="/contactus" onClick={closeMenu}>Contact</NavLink></li>
            </ul>
          </div>

         <div className="nav-right">
               <Link to="https://www.facebook.com/WasalaTours" target="_blank" rel="noopener noreferrer" className="nav-icon">
                 <FaFacebookF />
               </Link>
               <Link to="https://www.instagram.com/wasala_tours" target="_blank" rel="noopener noreferrer" className="nav-icon">
                 <FaInstagram />
               </Link>

               <button className="hamburger" onClick={toggleMenu}>
                 <span className="bar"></span>
                 <span className="bar"></span>
                 <span className="bar"></span>
               </button>
             </div>
        </div>
      </nav>

<main>
<ScrollToTop />
<BackToTopButton />
  <WhatsAppButton />
  <Routes>
    <Route path="/" element={<Navigate to="/home" />} />
    <Route path="/home" element={<Home />} />
    <Route path="/about" element={<About />} />
    <Route path="/contactus" element={<Contact />} />
    <Route path="/service" element={<ServiceMain />} />
    <Route path="/gallery" element={<Gallery />} />
    <Route path="/srilanka" element={<InfoSection />} />
    <Route path="/srilankatours" element={<SriLanka />} />
    <Route path="/chinatours" element={<China />} />
    <Route path="/srilankaview" element={<BeutyOfSriLanka />} />
    <Route path="/kandy" element={<Kandy />} />
    <Route path="/dabulle" element={<Dabulle />} />
    <Route path="/anuradhapura" element={<Anuradhapura />} />
    <Route path="/polonnaruwa" element={<Polonnaruwa />} />
    <Route path="/yala" element={<Yala />} />
    <Route path="/galle" element={<Galle />} />
    <Route path="/jaffna" element={<Jaffna />} />
    <Route path="/nuweraelliya" element={<NuweraElliya />} />
    <Route path="/ella" element={<Ella />} />
    <Route path="/colombo" element={<Colombo />} />
    <Route path="/china" element={<InfoSectionChina />} />
    <Route path="/beijing" element={<Beijing />} />
    <Route path="/shanghai" element={<Shanghai />} />
    <Route path="/guangzhou" element={<Guangzhou />} />
    <Route path="/xian" element={<Xian />} />
    <Route path="/wuhan" element={<Wuhan />} />
    <Route path="/chengdu" element={<Chengdu />} />
    <Route path="/zhangjiajie" element={<Zhangjiajie />} />
    <Route path="/chengdu" element={<Chengdu />} />
    <Route path="/chengdu" element={<Chengdu />} />
    <Route path="/guilin" element={<Guilin />} />
    <Route path="/hangzhou" element={<Hangzhou />} />
     <Route path="/harbin" element={<Harbin />} />
     <Route path="/Wasala_Lake_Menu" element={<QR />} />
    <Route path="*" element={<Navigate to="/home" />} />
  </Routes>
</main>



    </div>
  );
};

const AppWrapper = () => (
  <Router>
  <ScrollToTop />
  <BackToTopButton />
    <App />
  </Router>
);

export default AppWrapper;
